import { useEffect } from "react";
import Lenis from "lenis";
import { Navbar } from "./Navbar";
import { Hero } from "./Hero";
import { FeatureCards } from "./FeatureCards";
import { CinematicSection } from "./CinematicSection";
import { SafetyPillars } from "./SafetyPillars";
import { AppPreview } from "./AppPreview";
import { LaunchCountdown } from "./LaunchCountdown";
import { ReferralLeaderboard } from "./ReferralLeaderboard";
import { FAQ } from "./FAQ";
import { ClosingCTA } from "./ClosingCTA";
import { Footer } from "./Footer";
import { CookieBanner } from "./CookieBanner";

export const LandingPage = () => {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.15, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <div className="min-h-screen overflow-x-clip bg-cream font-sans text-ink">
      <Navbar />
      <main className="relative z-[1]">
        <Hero />
        <FeatureCards />
        <CinematicSection />
        <SafetyPillars />
        <AppPreview />
        <LaunchCountdown />
        <ReferralLeaderboard />
        <FAQ />
        <ClosingCTA />
      </main>
      <Footer />
      <CookieBanner />
    </div>
  );
};
